import { type ChainId, chains } from '@endure/chains';
import areAddressesEqual from 'utilities/areAddressesEqual';

export const isPoolIsolated = ({
  chainId,
  comptrollerAddress,
}: { chainId: ChainId; comptrollerAddress: string }) => {
  const { corePoolComptrollerContractAddress } = chains[chainId];

  return (
    !corePoolComptrollerContractAddress ||
    !areAddressesEqual(corePoolComptrollerContractAddress, comptrollerAddress)
  );
};
